// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iw-0";
export var actionModalContentContainer = "_iw-1";
export var createTagButton = "_iw-2";
export var footerContainer = "_iw-7";
export var fullWidthDivider = "_iw-3";
export var hasCreateTagButton = "_iw-4";
export var noCreateTagButton = "_iw-5";
export var tagsContainer = "_iw-6";
export var tagsModalContentContainer = "_iw-8";